module.exports = __webpack_public_path__ + "img/slide12_vn.7b46a0af.jpg";